import React from 'react'
import {
  Calculator,
  FormulaSheetTool,
  Highlight,
  MobileToolsMenu,
  OptionalListItem,
  Strikethrough,
} from './components'
import { StyledBox } from './styles'
import { AccessibilityTestMenuContainer } from '@app/components/ui'
import { useMediaQuery, useTheme } from '@mui/material'

type Props = {
  isReviewMode?: boolean
}

const TestToolsMenu: React.FC<Props> = ({ isReviewMode = false }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('mobile'))

  if (isMobile) {
    return <MobileToolsMenu isReviewMode={isReviewMode} />
  }

  return (
    <StyledBox component='ul' aria-label='Test tools'>
      <OptionalListItem>
        <Calculator isReviewMode={isReviewMode} />
      </OptionalListItem>
      <OptionalListItem>
        <FormulaSheetTool />
      </OptionalListItem>
      <OptionalListItem>
        <Highlight isReviewMode={isReviewMode} />
      </OptionalListItem>
      <OptionalListItem>
        <Strikethrough isReviewMode={isReviewMode} />
      </OptionalListItem>
      <OptionalListItem>
        <AccessibilityTestMenuContainer isReviewMode={isReviewMode} />
      </OptionalListItem>
    </StyledBox>
  )
}

export default TestToolsMenu
